<template>
  <div class="showTask">
    <!-- <div class="goback">
      <span @click="$router.back()">返回</span>
    </div> -->
    <div class="base-info">
      <div class="top">任务详情</div>
      <el-form v-model="baseInfo" label-width="140px" label-position="right">
        <el-form-item label="任务ID:">
          {{ baseInfo.id }}
        </el-form-item>
        <el-form-item label="任务名称:" prop="taskName">
          {{ baseInfo.executionName }}
        </el-form-item>
        <el-form-item label="调查员手机号:">
          {{ baseInfo.executorPhone }}
        </el-form-item>
        <el-form-item prop="executionValidateTo" label="截止时间:">
          {{ baseInfo.executionValidateTo }}
        </el-form-item>
        <el-form-item prop="settleMode" label="结算方式:">
          <div v-if="baseInfo.settleMode===1">按答卷数量</div>
          <div v-if="baseInfo.settleMode===2">按天</div>
          <div v-if="baseInfo.settleMode===3">按阶梯计价</div>
        </el-form-item>
        <div v-if="baseInfo.settleMode===1">
          <el-form-item prop="settleRule.unitPriceYuan" label="单价:">
            {{ baseInfo.settleRule.unitPriceYuan }}<span>元</span>
          </el-form-item>
          <el-form-item prop="settleRule.expectedQuantity" label="答卷数量:">
            {{ baseInfo.settleRule.expectedQuantity }}<span>份</span>
          </el-form-item>
        </div>
        <div v-if="baseInfo.settleMode===2">
          <el-form-item prop="settleRule.unitPriceYuan" label="单价:">
            {{ baseInfo.settleRule.unitPriceYuan }}<span>元</span>
          </el-form-item>
          <el-form-item prop="settleRule.expectedQuantity" label="天数:">
            {{ baseInfo.settleRule.expectedQuantity }}<span>天</span>
          </el-form-item>
        </div>
        <div v-if="baseInfo.settleMode===3">
          <div style="padding:0;margin:0 0 12px;background:transparent" class="settlementType-style" v-if="baseInfo.settleMode === 3">
            <el-form-item style="margin-bottom: 0" label="单价:">
              <div
                class="flex-settlement"
                v-for="(item, index) in baseInfo.settleRule.tiers"
                :key="index"
                :style="{ marginBottom: index === baseInfo.settleRule.tiers.length - 1 ? '0px' : '5px' }"
              >
                <span style="margin-right: 8px" v-show="index === 0">每天</span>
                <span>{{item.quantityLowerBound}}</span>
                <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                <span>{{item.quantityUpperBound}}</span>
                <span style="margin: 0 8px">份，按完成量</span>
                <span>{{item.unitPriceYuan}}</span>
                <span style="margin-left: 8px">元/份</span>
                <!-- <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                  ><i class="icon-font">&#xe68c;</i></el-button
                >
                <el-button
                  v-else-if="index === baseInfo.settleRule.tiers.length - 1"
                  @click="handleSettlement('remove', index)"
                  class="btn-style"
                  type="text"
                  ><i class="icon-font">&#xe68a;</i></el-button
                > -->
              </div>
              <!-- <div class="settlement-tips left-0">
                若用线上结算，请填写调查员到手金额，到手金额
                <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
              </div> -->
            </el-form-item>
          </div>
          <el-form-item prop="settleRule.expectedQuantity" label="天数:">
            {{ baseInfo.settleRule.expectedQuantity }}<span>天</span>
          </el-form-item>
        </div>
        <!-- <el-form-item prop="executionQuantity" label="答卷数量:">
          {{ baseInfo.executionQuantity }}
        </el-form-item>
        <el-form-item prop="executionSinglAmount" label="答卷单价:">
          {{ baseInfo.executionSingleAmount }}
        </el-form-item> -->
        <el-form-item label="描述:">
          {{ taskInfo.executionDescription }}
        </el-form-item>
      </el-form>
    </div>
    <div class="answer-info">
      <div class="top">费用计算</div>
      <el-form label-width="140px" v-model="answerInfo" label-position="right">
        <el-form-item label="提交数量:">{{ answerInfo.recycledQuantity }}</el-form-item>
        <el-form-item label="有效数量:">{{ answerInfo.effectiveQuantity }}</el-form-item>
        <el-form-item label="需支付:">{{ answerInfo.needPay }}</el-form-item>
      </el-form>
    </div>
    <div class="submit-btn">
      <el-button @click="$emit('cancel')" style="width:88px">取消</el-button>
      <el-button type="primary" @click="onClickSettlement">确定并支付</el-button>
    </div>
  </div>
</template>

<script>
  import { getAwardOrder } from '@/api/wenjuan/reward'
  import GlobalConfig from '@/global/config'

  export default {
    name: 'showTask',
    props:['rows'],
    data() {
      return {
        taskInfo: null,
        baseInfo: {},
        answerInfo: {
          /* recycledQuantity: 0,
            effectiveQuantity: 0,
            needPay: 0*/
        }
      }
    },
    watch:{
      rows:{
        handler:function(rows){
          this.taskInfo = rows;
          this.answerInfo= rows;
        },
        deep:true
      }
    },
    methods: {
      onClickSettlement() {
        let { id, executionSingleAmount, executionBy } = this.baseInfo
        getAwardOrder({
          surveyId: GlobalConfig.getSurveyId(),
          executionId: id,
          effectiveQuantity: this.answerInfo.effectiveQuantity,
          executionSinglAmount: executionSingleAmount,
          executionBy,
          orderSource: 2
        }).then((res) => {
          if(res.data.code!=0) {
            this.$message.error(res.data.msg)
            return;
          }
          this.$store.commit('SET_AWARD_INFO', { ...res.data.data, executionBy, executionId: id, isOffline: true })
          this.$emit('toPay');
          // this.$router.push({
          //   path: `/survey/${GlobalConfig.getSurveyId()}/offline/assign-sample-interview/pay`,
          //   query: {
          //     id: GlobalConfig.getSurveyId()
          //   }
          // })
        })
      },
      initInfo() {
        let {
          offlineId,
          executionSingleAmount,
          executionDescription,
          executionBy,
          executionValidateTo,
          executionQuantity,
          executionName,
          executorPhone,
          settleMode,
          settleRule
        } = this.taskInfo
        this.baseInfo = {
          id: offlineId,
          executionName,
          executorPhone,
          executionBy,
          executionValidateTo,
          executionQuantity,
          executionSingleAmount,
          executionDescription,
          settleMode,
          settleRule
        }
        this.answerInfo = {
          recycledQuantity: this.taskInfo.recycledQuantity,
          effectiveQuantity: this.taskInfo.effectiveQuantity,
          needPay: this.taskInfo.effectiveQuantity * this.taskInfo.executionSingleAmount
        }
      }
    },
    created() {
      // this.taskInfo = this.$route.query;
      console.log(this.rows);
      this.taskInfo = this.rows;
      this.answerInfo= this.rows;
      this.initInfo()
    }
  }
</script>

<style scoped lang="scss">
  .showTask {
    .goback {
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }

    .base-info,
    .answer-info {
      border: 1px solid #f2f6fc;
      padding: 20px 30px;
      margin-bottom: 30px;

      .top {
        font-size: 16px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.7);
      }

      .el-form {
        width: 760px;
        margin: 0 auto;

        .el-form-item {
          margin-bottom: 22px;
        }
        .settlementType-style {
          .el-form-item {
            margin-bottom: 0px;
          }
          .flex-settlement{
            span{
              color: #000;
            }
          }
        }

        .el-form-input {
          width: 220px;
        }
      }
    }

    .submit-btn {
      margin-top: 30px;
      text-align: center;
    }
  }
</style>
